import React, { useState, useEffect } from 'react';
import { faArrowLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AddRoad } from '@mui/icons-material';
import CustomToastContainer from '../components/CustomToastContainer';
import { getAllRoutes } from '../apiServices/apiServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

export default function AllRoutes() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const response = await getAllRoutes();
        // console.log("Response:", response);
        if (response && response.success) {
          setData(response.data.complete_routes || []);
        } else {
          toast.error(response.message || 'Failed to fetch routes');
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('An error occurred. Please try again.');
      }
    };
    fetchRoutes();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <div className="h-screen bg-gray-100">

      <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>

          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
              Main Routes
            </h1>
          </div>
        </nav>
        
        <ul className="list-none p-2">
          {data && data.map((item, index) => (
            <li
              key={item.id}
              onClick={() => navigate('/completeRoutes', { state: { item } })}
              className="bg-gray-200 my-2 p-4 rounded-md flex items-center cursor-pointer"
            >
              <AddRoad className="text-[#BE1F18] mr-2" />
              <span className="flex-1">{item.user_readable_name}</span>
              <FontAwesomeIcon icon={faChevronRight} className="text-[#111111]" />
            </li>
          ))}
        </ul>
      </div>
      <CustomToastContainer />
    </>
  );
}
